import 'react-app-polyfill/ie11';
import React from 'react';
import { render } from 'react-dom'
import './assets/ak-cached/24h/css/App.css';
import './assets/ak-cached/24h/css/vzrf.min.css';
import './assets/ak-cached/24h/css/bundle.css';
import './assets/ak-cached/24h/css/header.css';
import './assets/ak-cached/24h/css/buildProduct.css';
import './assets/ak-cached/24h/css/moves.css';
import './assets/ak-cached/24h/css/checkout.css';
import './assets/ak-cached/24h/css/loopQualification.css';
import './assets/ak-cached/24h/css/submitOrder.css';
import './assets/ak-cached/24h/css/movesLanding.css';
import './assets/ak-cached/24h/css/urc.css';
import './assets/ak-cached/24h/css/orderSum.css';
import './assets/ak-cached/24h/css/ecOrderSummary.css';
import './assets/ak-cached/24h/css/nsi.css';
import './assets/ak-cached/24h/css/fccLabel.css'
import './assets/ak-cached/24h/css/urcRecommendation.css';
import './assets/ak-cached/24h/css/perks.css';
import {unregister} from './registerServiceWorker';
import { createLogger } from 'redux-logger'
import { createStore, applyMiddleware,compose  } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import reducer from './reducers'
import App from './app'
import { createBrowserHistory } from 'history'
import { routerMiddleware, connectRouter } from 'connected-react-router'
import { persistStore, persistReducer } from 'redux-persist'
//import storageSession from 'redux-persist/lib/storage/session'
import storage from 'redux-persist/lib/storage'
//import createCompressEncryptor from 'redux-persist-transform-compress-encrypt'
import { PersistGate } from 'redux-persist/integration/react'
//import { registerObserver } from 'react-perf-devtool';
import ErrorBoundary from '../src/ErrorBoundary';

window.addEventListener("error" , (event) => {
  if(event?.message?.includes("_detector")){
    console.log("Critical:", error?.message);
    event.preventDefault();
  }
})
//DO NOT MERGE THIS IN BUG-STILL IN TESTING PHASE - START
// const transformer = createCompressEncryptor({
//   secretKey: 'secret-key',
//   onError: function(error) {
//     console.log(error);
//       //fired whenever there is any issue with transformation, 
//       //compression or encryption/decryption
//   }
// });

const persistConfig = {
  key: 'root',
  storage:storage,
  //transforms: [transformer]
}
//DO NOT MERGE THIS IN BUG-STILL IN TESTING PHASE - END

const persistedReducer = persistReducer(persistConfig, reducer)
const history = createBrowserHistory()

// registerObserver({}, (measures) => {
//   console.log(measures);
//   });

const middleware = [thunk];
if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger());
}

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  connectRouter(history)(persistedReducer),
  composeEnhancer(
    applyMiddleware(
      routerMiddleware(history),
    ),
  ),
)
let persistor = persistStore(store)
const Wrapper = window?.sessionStorage?.getItem("fiosReferralFlow") === "true" ? ErrorBoundary : React.Fragment;


  render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Wrapper>
         <App history={history} />        
        </Wrapper>
      </PersistGate>
    </Provider>, document.getElementById('root') || document.createElement('div')
  );
unregister();

